import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter, Routes, Route, NavLink } from "react-router-dom";
import Login from "./component/Login";
import Navbar from "./component/Navbar";
import Home from "./component/Home";

function App() {
  return (
    <div>
      <BrowserRouter>
        {/* <Navbar /> */}
        {/* <Login /> */}
        <Routes>
          <Route path="/home" element={<Home />} />
          <Route path="/login" element={<Login />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
